/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var HandThumbUpIcon20Solid = forwardRef('HandThumbUpIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "m7 8 3.142-6.174A1.511 1.511 0 0 1 13 2.51V7h3.681a2.25 2.25 0 0 1 2.194 2.749l-1.278 5.624A3.375 3.375 0 0 1 14.306 18H7V8Z" }),
        React.createElement("path", { d: "M3.5 8A1.5 1.5 0 0 0 2 9.5v7A1.5 1.5 0 0 0 3.5 18H6V8H3.5Z" })));
});
